import React from 'react'
import SeleccionEmpleados from '../incidenciasregistro/SeleccionEmpleados'
import { obtenerincidenciasxlotes } from '../../../Redux/LotesDucks'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from "react-router-dom";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import MenuPerfil from '../../loggin/MenuPerfil'
import { Divider, Grid, Typography } from '@mui/material';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DetallesLotes = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { open } = props
    const { appbar } = props

    let { Id } = useParams();

    const dataincidencia = useSelector(store => store.lote.incidencias);


    const obtenerdatolote = (Id) => {
        dispatch(obtenerincidenciasxlotes(Id))
    }

    React.useEffect(() => {
        const obtenerDatos = async () => {
            dispatch(obtenerincidenciasxlotes(Id))
        }
        obtenerDatos()

    }, [Id])

    React.useEffect(() => {
        const obtenerDatos = async () => {
            dispatch(obtenerincidenciasxlotes(Id))
        }
        setTimeout(obtenerDatos, 2000)

    }, [dispatch])

    /*    React.useEffect(() => {
           const obtenerDatos = async () => {
               dispatch(obtenerempleadoactivo(bdc, iddepta))
           }
           setTimeout(obtenerDatos, 3000)
       }, [bdc, iddepta])
    */
    const periodo = {
        idperiodo: dataincidencia.idperiodo,
        numeroperiodo: dataincidencia.numeroperiodo,
        ejercicio: dataincidencia.ejercicio,
        fechainicio: dataincidencia.fechainicio,
        fechafin: dataincidencia.fechafin
    }

    const pedim = dataincidencia.pdim || []

    const depta = {
        iddepartamento: dataincidencia.iddepartamento,
        descripcion: dataincidencia.descdepto
    }

    return (
        <>
            <AppBar position="absolute" color='info' open={open} elevation={0}>
                <Toolbar
                    sx={{
                        pr: '24px', // keep right padding when drawer closed
                    }}
                >

                    <IconButton
                        edge="start"
                        color='success'
                        aria-label="open drawer"
                        onClick={appbar}
                        sx={{
                            marginRight: '36px',
                            ...(open && { display: 'none' }),
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Grid container>
                        <Grid item sm={6} xs={12} md={6}>
                            <Typography variant='h5'>Selección de empleados</Typography>
                        </Grid>
                    </Grid>

                    <MenuPerfil />
                </Toolbar>
                <Divider />
            </AppBar>
            <Grid container>
                <Grid item sm={6} md={6}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link underline="hover" color="inherit" onClick={e => navigate(-1)}>
                            Incidencias
                        </Link >
                        <Link
                            underline="none"
                            color="text.primary"
                            aria-current="page"
                        >
                            Detalles
                        </Link>
                    </Breadcrumbs>
                </Grid>
                <Grid item sm={6} md={6}>

                    <Typography align='right'>{dataincidencia.empresa}</Typography>

                </Grid>
            </Grid>


            <SeleccionEmpleados
                lote={dataincidencia.idlote}
                bd={dataincidencia.guidempresa}
                depta={depta}
                periodo={periodo}
                detalle={true}
                pdim={pedim}
                obtenerdatolote={obtenerdatolote}
            />
        </>
    )
}

export default DetallesLotes
